
const digest = '8c02f11cf2ad8a27c7d2690bebf9e80498cf6ade9a42fcf826a044687428a129';
const classes = {"wrapper":"_wrapper_1xni0_1"};
const css = `._wrapper_1xni0_1 {
  display: flex;
  gap: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  